<template>
	<v-container>
        <Curso :mostrar="abrirCurso" :cursoEdicao="curso" @fecharCurso="fecharCurso()" @cursoCadastrado="incluirCursoCadastrado($event)" @cursoAtualizado="alterarCursoAtualizado($event)"/>
        <Ativos :mostrar="abrirAtivos" :cursos="itens.ativos" @fechar="fecharAtivos()" @editarCurso="editar($event)" @excluirCurso="excluir($event)" @inativarCurso="inativarCurso($event)"/>
        <Inativos :mostrar="abrirInativos" :cursos="itens.inativos" @fechar="fecharInativos()" @editarCurso="editar($event)" @excluirCurso="excluir($event)" @ativarCurso="ativarCurso($event)"/>
		<Excluir :mostrar="abrirExcluir" :curso="curso" @cursoExcluido="retirarCursoExcluido($event)" @fecharExcluir="fecharExcluir()"/>
        
		<v-row>
			<v-col>
				<v-card :loading="loading">
					<v-card-title>
						<h1>Cursos </h1><v-spacer></v-spacer><v-btn class="mx-4" color="primary" small @click="CadastrarNovoCurso()">Novo</v-btn> <v-chip color="primary">{{cursos.total}}</v-chip>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card>
										<v-card-title>
											<h5>Ativos</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('A')">{{cursos.ativos}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card >
										<v-card-title>
											<h5>Inativos</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('I')">{{cursos.inativos}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import axios from 'axios'
	import { baseApiUrl, showSuccess } from "@/config/global"
    import Curso from '@/components/admin/cursos/Curso'
    import Ativos from '@/components/admin/cursos/Ativos'
	import Inativos from '@/components/admin/cursos/Inativos'
	import Excluir from '@/components/admin/cursos/ExcluirCurso'
	

	export default{
		name: 'AdminCursos',
		components: { 
            Curso,
            Ativos,
			Inativos,
			Excluir
			},
		computed:{
			textosPendentes(){
				
				let texto = ""

				if(this.publicacoes.pendentes == 0){
					texto = 'Não há textos para aprovar'
				}else if(this.publicacoes.pendentes == 1){
					texto = 'Há 1 texto aguardando aprovação'
				}else{
					texto = 'Há ' + this.publicacoes.pendentes + ' textos aguardando aprovação'
				}

				return texto
			},
		},
		data(){
			return{
				itens: {
					ativos: [],
					inativos: []
				},
				avisos: {},
                loading: false,
                curso: {},
                cursos: {
                    ativos: 0,
                    inativos: 0
                },
                abrirCurso: false,
                abrirNovoModulo: false,
                abrirInativos: false,
				abrirAtivos: false,
				abrirExcluir: false
			}
		},

		methods:{
            alterarCursoAtualizado(curso){
				if(curso.ativo == 1){
					this.itens.ativos.forEach(v => {
						if(v.id == curso.id){
							v = curso
						}
					})
				}else{
					this.itens.inativos.forEach(v => {
						if(v.id == curso.id){
							v = curso
						}
					})
				}
			},
			buscaCursos(){
				axios.get(`${baseApiUrl}/Cursos/read.php`)
				.then(res => {
					if(res.data.codigo == "01"){
						this.cursos = res.data.cursos
                        this.loadingCursos = false
					}
				})
			},

			CadastrarNovoCurso(){
                this.abrirCurso = true
			},

			buscaDetalhes(d){
				this.loading = true
				axios.get(`${baseApiUrl}/Cursos/cursosPorStatus.php?status=${d}`).then(res => { 
					if(res.data.codigo == "01"){ 
						if(d == 'A'){
							this.itens.ativos = res.data.cursos
                            this.abrirAtivos = true
							this.loading = false
						}else if(d == 'I'){
							this.itens.inativos = res.data.cursos
                            this.abrirInativos = true
                            this.loading = false
                        }
                    }
				})	
			},

			abrirDetalhes(d){
				switch(d){
					case 'A':
					if(this.cursos.ativos > 0){
						if(this.itens.ativos.length > 0){
                            this.abrirAtivos = true
						}else{
							this.buscaDetalhes(d)
						}
					}else{
						showSuccess("Não há cursos ativos")
					}
					break

					case 'I':
					if(this.cursos.inativos > 0){
						if(this.itens.inativos.length){
                            this.abrirInativos = true
							//Br.setAbrirPublicacoesReprovadas(this.itens.reprovados)
						}else{
                            this.buscaDetalhes(d)
                        }
					}else{
						showSuccess("Não há cursos inativos")
					}
					break
				}
			},
			
			ativarCurso(curso){
				let idx = this.itens.inativos.findIndex(v => {
					return v.id == curso.id
				})

				this.itens.inativos.splice(idx, 1)
				this.cursos.inativos--
				if(this.itens.ativos.length > 0){
					this.itens.ativos.push(curso)
					this.cursos.ativos++
				}else{
					this.cursos.ativos++
				}
			},
            
            fecharCurso(){
				this.curso = {}
				this.abrirCurso = false
			},
			
			fecharExcluir(){
				this.curso = {}
				this.abrirExcluir = false
			},

            fecharAtivos(){
				this.curso = {}
                this.abrirAtivos = false
            },

            fecharInativos(){
				this.curso = {}
				this.abrirInativos = false
            },

            editar(curso){
                this.curso = curso
                this.abrirCurso = true
			},
			
			excluir(curso){
				this.curso = curso
				this.abrirExcluir = true
			},
			inativarCurso(curso){
				let idx = this.itens.ativos.findIndex(v => {
					return v.id == curso.id
				})

				this.itens.ativos.splice(idx, 1)
				this.cursos.ativos--
				if(this.itens.inativos.length > 0){
					this.itens.inativos.push(curso)
					this.cursos.inativos++
				}else{
					this.cursos.inativos++
				}
			},
			incluirCursoCadastrado(curso){
				if(this.itens.inativos){
					this.itens.inativos.push(curso)
				}
				this.cursos.inativos++
				this.cursos.total++
			},

			retirarCursoExcluido(crs){
				
				if(crs.status == 0){
					let idx = this.itens.inativos.findIndex(v => {
						return v.id == crs.id
					})

					this.itens.inativos.splice(idx, 1)
					this.cursos.inativos--
					this.cursos.total--
				}else{
					let idx = this.itens.ativos.findIndex(v => {
						return v.id == crs.id
					})

					this.itens.ativos.splice(idx, 1)
					this.cursos.ativos--
					this.cursos.total--
				}
				
				this.abrirExcluir = false
			}
		},

		created(){
			//this.loading = true
			this.buscaCursos()
			// Br.onCursoAtivado(publicacao => {
			// 		switch(publicacao.statusAtual){
			// 		case 'I':
			// 		this.publicacoes.inativos--
			// 		break
			// 		case 'A':
			// 		this.publicacoes.aprovados--
			// 		break
			// 		case 'P':
			// 		this.publicacoes.pendentes--
			// 		break
			// 	}

			// 	this.publicacoes.reprovados++
			// 	if(this.itens.reprovados){
			// 		this.itens.reprovados.push(publicacao)
			// 	}
			// })

			// Br.onCursoInativado(publicacao =>{
			// 	switch(publicacao.statusAtual){
			// 		case 'R':
			// 		this.publicacoes.reprovados--
			// 		break
			// 		case 'A':
			// 		this.publicacoes.aprovados--
			// 		break
			// 		case 'P':
			// 		this.publicacoes.pendentes--
			// 		break
			// 	}

			// 	this.publicacoes.inativos++
			// 	if(this.itens.inativos){
			// 		this.itens.inativos.push(publicacao)
			// 	}
			// })

		}
	}

</script>

<style scoped>

</style>